// Mock data for AIS Express delivery website

export const mockServices = [
  {
    id: 1,
    title: "Same-Day Delivery",
    description: "Get your products delivered across the UK within the same day. Perfect for urgent business needs.",
    features: ["Delivery within 1-12 hours", "Real-time tracking", "Secure handling", "Proof of delivery"],
    icon: "Truck"
  },
  {
    id: 2,
    title: "Express Delivery",
    description: "Ultra-fast delivery service for time-critical shipments. Priority handling guaranteed.",
    features: ["Delivery within 0-6 hours", "Priority processing", "Direct route", "SMS notifications"],
    icon: "Zap"
  },
  {
    id: 3,
    title: "Scheduled Delivery",
    description: "Plan your deliveries in advance with our flexible scheduling options for business efficiency.",
    features: ["Choose your time slot", "Advance booking", "Regular deliveries", "Business accounts"],
    icon: "Calendar"
  },
  {
    id: 4,
    title: "Bulk & Commercial",
    description: "Specialized service for large volume deliveries and commercial partnerships across the UK.",
    features: ["Volume discounts", "Dedicated support", "Custom solutions", "Fleet management"],
    icon: "Package"
  }
];

export const mockTestimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    company: "TechStart Ltd",
    rating: 5,
    text: "AIS Express saved our product launch! Same-day delivery across London was flawless. Highly professional service.",
    date: "2024-01-15"
  },
  {
    id: 2,
    name: "Michael Chen",
    company: "Creative Solutions",
    rating: 5,
    text: "Reliable, fast, and affordable. We've been using AIS Express for 6 months for all our client deliveries. Excellent communication.",
    date: "2024-01-10"
  },
  {
    id: 3,
    name: "Emma Williams",
    company: "Fashion Forward",
    rating: 4,
    text: "Great service for our fashion deliveries. The team is professional and handling is careful. Will definitely use again.",
    date: "2024-01-08"
  },
  {
    id: 4,
    name: "David Thompson",
    company: "BuildCorp",
    rating: 5,
    text: "Outstanding service for our construction supplies. Even handled urgent weekend deliveries. AIS Express is our go-to partner.",
    date: "2024-01-05"
  },
  {
    id: 5,
    name: "Lisa Rodriguez",
    company: "MedSupply UK",
    rating: 5,
    text: "Critical medical supplies delivered on time, every time. The reliability and care AIS Express shows is unmatched.",
    date: "2024-01-03"
  },
  {
    id: 6,
    name: "James Parker",
    company: "ElectroTech",
    rating: 4,
    text: "Smooth experience from booking to delivery. Great value for money and excellent customer service team.",
    date: "2024-01-01"
  }
];

export const mockStats = [
  {
    number: "15,000+",
    label: "Successful Deliveries",
    icon: "CheckCircle"
  },
  {
    number: "98%",
    label: "On-Time Delivery Rate",
    icon: "Clock"
  },
  {
    number: "100+",
    label: "Satisfied Business Partners",
    icon: "Users"
  },
  {
    number: "24/7",
    label: "Customer Support",
    icon: "Phone"
  }
];

export const mockCoverageAreas = [
  "Reading", "Slough", "Wokingham", "Bracknell", "Windsor", "Maidenhead", 
  "Basingstoke", "Farnborough", "London", "Manchester", "Birmingham", "Leeds"
];

export const mockFAQs = [
  {
    id: 1,
    question: "How do I get a quote for delivery?",
    answer: "Simply call us at 01344 508095 with your pickup and delivery details. Our team will provide an instant quote based on distance, urgency, and package specifications."
  },
  {
    id: 2,
    question: "What areas do you cover?",
    answer: "We provide same-day delivery services across the entire UK, with specialized coverage in major cities including London, Manchester, Birmingham, and all surrounding areas."
  },
  {
    id: 3,
    question: "What types of items can you deliver?",
    answer: "We handle a wide range of items including business documents, retail products, medical supplies, automotive parts, and more. Contact us for specific item requirements."
  },
  {
    id: 4,
    question: "How do I track my delivery?",
    answer: "Once your delivery is dispatched, you'll receive tracking information via SMS and email. You can also call our support team for real-time updates."
  },
  {
    id: 5,
    question: "Do you offer regular business accounts?",
    answer: "Yes! We provide tailored solutions for businesses with regular delivery needs, including volume discounts and dedicated account management."
  }
];

export const contactInfo = {
  phone: "01344 508095",
  email: "customersupport@aisexpress.co.uk",
  address: "Bracknell, United Kingdom",
  hours: "24/7 Customer Support Available"
};